import React from 'react';
import DesignerVarSelect from './DesignerVarSelect.js';

import { formatNumber, roundNumber } from './functions.js';


class DesignerBasketForm extends React.Component {

    constructor(props) {
        super(props);

        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.handleVarSelect = this.handleVarSelect.bind(this);
        this.handleAddToBasket = this.handleAddToBasket.bind(this);
        this.handleEditSave = this.handleEditSave.bind(this);
    }

    handleEditSave(e) {
        e.preventDefault();
        this.props.onEditSave(e);
    }

    handleVarSelect(variant) {
        this.props.onVarSelect(variant);
    }

    handleAddToBasket(e) {
        e.preventDefault();
        this.props.onAddToBasket(e);
    }

    handleAmountChange(e) {
        this.props.onAmountChange(e.target.value);
    }

    render() {
        if (this.props.submitMode == 'edit')
        {
            return (
                <div className="designer_basket_form">
                    <div className="hundeshop-detailsinfo">
                        <div className="zoxid-detailsbox zoxid-detailsdescription" style={{textAlign: 'left', padding: '5px'}}>
                            <br />
                            Wenn du mit deinem Design zufrieden bist klicke hier um es zu speichern:
                        </div>
                        <div className="zoxid-detailstobasket" >
                            <button style={{height: '45px', fontSize: '20px'}} onClick={this.handleEditSave} id="toBasket" type="submit" className="tspdToBasket btn btn-info" title="Speichern">
                                Speichern
                            </button>
                            <br />
                            <br />
                            <br />
                        </div>
                    </div>
                </div>
            );
        }

        

        this.varSelectStarted = (this.props.activeDesignerVariants.find(vari => { return vari.selectedVar === null || !vari.varUserSelected }) === undefined);
        let varNotAvailableInfo = this.varSelectStarted;
        let basketDisabled = 'disabled';
        let productVar = this.props.productData;

        if ((this.varSelectStarted || this.props.submitMode == 'directdesign') && 
            (this.props.activeProductVar !== null && this.props.activeProductVar !== undefined))
        {
            varNotAvailableInfo = true;
            productVar = this.props.activeProductVar;

            if ((productVar.stock > 0 || productVar.stock_flag == "4" || productVar.stock_flag == "1") || this.props.submitMode == 'directdesign')
            {
                varNotAvailableInfo = false;
                basketDisabled = '';
            }
        }

        let discountPercent = null;
        let oldPrice = null;
        if (productVar.saved_percent > 0)
        {
            discountPercent = (
                <div>
                    <div className="hundeshop-details-saved">
                        {productVar.saved_percent}% <br />sparen!
                    </div>
                    <div className="clearfix"></div>
                </div>
            );

            oldPrice = (
                <span>statt <span className="productPrice_value oldPrice">{formatNumber(productVar.old_price)}</span> €</span>
            );
        }

        let freeShipping = null;
        if (productVar.is_free_shipping)
        {
            freeShipping = (
                <span><span className="free">kostenloser</span> Versand</span>
            );
        }


        let varSelects = null;
        if (this.props.designerVars !== undefined)
        {
            varSelects = this.props.designerVars.map((variant, index) =>
                <DesignerVarSelect
                    key={index}
                    variant={variant}
                    activeDesignerVariants={this.props.activeDesignerVariants}
                    onVarSelect={this.handleVarSelect}
                />
            );
        }
        

        if (this.props.submitMode == 'directdesign')
        {
            return (
                <div className="designer_basket_form">
                    <div className="hundeshop-detailsinfo">

                        {varSelects}

                        <div className="zoxid-detailsbox zoxid-detailsdescription" style={{textAlign: 'left', padding: '5px'}}>
                            <br />
                            Wenn du mit deinem Design zufrieden bist klicke hier um es zu speichern:
                        </div>

                        <div className="zoxid-detailstobasket" >
                            {
                                basketDisabled == 'disabled' ?
                                    <div className="designer_basket_form_disabled_info">
                                        Bitte wähle zuerst eine Variante aus.
                                    </div>
                                : null
                            }
                            <button style={{height: '45px', fontSize: '20px'}} onClick={this.handleEditSave} id="toBasket" type="submit" className="tspdToBasket btn btn-info" title="Speichern">
                                Speichern
                            </button>
                            <br />
                            <br />
                            <br />
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="designer_basket_form">
                <div className="hundeshop-detailsinfo">

                    {discountPercent}

                    { this.props.isDesignerAddonMode && this.props.addonArticleName ?
                        <div className="zoxid-detailsbox zoxid-detailsdescription" style={{textAlign: 'left', padding: '10px'}}>
                            <br />
                            Passend für: {this.props.addonArticleName}
                        </div>
                        : varSelects }

                    {
                        varNotAvailableInfo ?
                            <div className="varNotAvailableInfo" style={{ display: 'block' }}>
                                Diese Variante ist zur Zeit nicht lieferbar
                            </div>
                        : null
                    }
                    
                    <div className="zoxid-detailsbox zoxid-detailsdescription">
                        <div className="hundeshop-price">

                            {oldPrice}&nbsp;

                            <strong>
                                <span className="productPrice_value ">{formatNumber(productVar.price)}</span> € 
                            </strong>                    
                        </div>
                        <p>
                            inkl. MwSt <br /> zzgl.
                            <a href="#" data-toggle="modal" data-target="#modal_vs">Versandkosten</a><br />
                            <span className="productArtnum">ArtNr.: {productVar.artnum}</span>
                        </p>
                        <div className="detail-hintbox">
                            
                            {freeShipping}

                        </div>
                    </div>
                    <div className="zoxid-detailstobasket" >
                        {
                            basketDisabled == 'disabled' ?
                                <div className="designer_basket_form_disabled_info">
                                    Bitte wähle zuerst eine Variante aus.
                                </div>
                            : null
                        }

                        <input onChange={this.handleAmountChange} ref={(ref) => {this.articleAmountInput = ref}} className="form-control zoxid-productamount" disabled={basketDisabled} id="product_designer_to_basket" type="text" name="am" value={this.props.basketAmount} size="3" autoComplete="off" />
                        <button style={{height: '45px', fontSize: '20px'}} onClick={this.handleAddToBasket} id="toBasket" type="submit" className="tspdToBasket btn btn-info" disabled={basketDisabled} title="Warenkorb">
                            Warenkorb
                        </button>
                    </div>
                    <div className="details-infofooter hidden-xs">
                        <ul className="rating rating-big" itemProp="aggregateRating" itemScope="" itemType="http://schema.org/AggregateRating">
                            <li className="currentRate" style={{ width: (this.props.productData.rating_avg * 100 / 5) + '%' }}>
                                <meta itemProp="ratingValue" content="4.8" />
                                <meta itemProp="reviewCount" content="17" />
                                <meta itemProp="bestRating" content="5" />
                                <meta itemProp="worstRating" content="1" />
                                <span title="96"></span>
                            </li>
                        </ul>
                        <span className="rating-count">{this.props.productData.rating_count} Bewertungen</span>             
                        <br />       
                        <br />       
                    </div>
                </div>
            </div>
        );
    }
  }
export default DesignerBasketForm;



// WEBPACK FOOTER //
// ./src/DesignerBasketForm.js